import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { add } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button as BaseButton } from "../../../Button/Button";
import { MonthYearControlsProps } from "../MonthYearControls";
type UseGetMonthStepButtonsOptions = Omit<MonthYearControlsProps, "toggleOpen">;
const Button = styled(BaseButton)`
  min-width: 3rem;
  min-height: 2.5rem;
`;
export function useGetMonthStepButtons({
  monthOffset,
  selectedDate,
  onChange
}: UseGetMonthStepButtonsOptions) {
  const {
    i18n,
    t
  } = useTranslation();
  const locale = i18n.language;
  const nextMonthDate = add(selectedDate ?? new Date(), {
    months: monthOffset + 1
  }).toLocaleString(locale, {
    month: "long",
    year: "numeric"
  });
  const previousMonthDate = add(selectedDate ?? new Date(), {
    months: monthOffset - 1
  }).toLocaleString(locale, {
    month: "long",
    year: "numeric"
  });
  function NextMonthButton() {
    return <Button variant="tertiary" aria-label={t("nextMonth", {
      nextMonthDate
    })} onClick={() => onChange(monthOffset + 1)} data-sentry-element="Button" data-sentry-component="NextMonthButton" data-sentry-source-file="useGetMonthStepButtons.tsx">
        <FontAwesomeIcon icon={i18n.dir() === "rtl" ? faChevronLeft : faChevronRight} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="useGetMonthStepButtons.tsx" />
      </Button>;
  }
  function PreviousMonthButton() {
    return <Button variant="tertiary" aria-label={t("previousMonth", {
      previousMonthDate
    })} onClick={() => onChange(monthOffset - 1)} data-sentry-element="Button" data-sentry-component="PreviousMonthButton" data-sentry-source-file="useGetMonthStepButtons.tsx">
        <FontAwesomeIcon icon={i18n.dir() === "rtl" ? faChevronRight : faChevronLeft} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="useGetMonthStepButtons.tsx" />
      </Button>;
  }
  return {
    NextMonthButton,
    PreviousMonthButton
  };
}